import { render, staticRenderFns } from "./associationNotice.vue?vue&type=template&id=61e4523b&scoped=true&"
import script from "./associationNotice.vue?vue&type=script&lang=js&"
export * from "./associationNotice.vue?vue&type=script&lang=js&"
import style0 from "./associationNotice.vue?vue&type=style&index=0&id=61e4523b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e4523b",
  null
  
)

export default component.exports